import axios from "axios";
import toast from 'toasted-notes'
import 'toasted-notes/src/styles.css';


class BaseService {
    HOST = '';

    constructor() {
        this.HOST = process.env.REACT_APP_HOST;
        this.HOST2 = process.env.EXPORT_API;
    }

    createHeader(){

      this.service = axios.create({
          headers: {
              'Authorization': this.authHeader(),
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Access-Control-Allow-Credentials': 'true',
              'Access-Control-Expose-Headers': 'X-refreshtoken, X-Authorization, X-Access-Token, X-Uid, X-Requested-With',
              'Access-Control-Allow-Headers': 'X-Requested-With, Origin, X-Requested-With, Content-Type, Accept, Authorization, refreshtoken, X-refreshtoken, X-Authorization, X-Access-Token, X-Uid'
          }
      });
      this.service.interceptors.response.use(this.handleSuccess, this.handleError);
    }

    authHeader() {
        let json = localStorage.getItem('user')
        if(json === 'undefined'){
            return '';
        }

        let user = JSON.parse(json);

        if (user && user.token) {
            return 'Bearer ' + user.token;
        } else {
            return '';
        }
    }

    handleSuccess(response) {
        return response;
    }

    handleError(error){
        console.log("ERROR", error.response.status, error)
        if (!error || !error.response){
            return Promise.reject(error)
        }
        switch (error.response.status) {
            case 401:
                //let  history = useHistory()
                //history.push("/login");
                //history.pushState(null, 'login');
                break;
            case 404:
                break;
            default:
                break;
        }
        return Promise.reject(error)
    }

    doRequest(params, callback, isLogin=false, withHeader=true){
        if(withHeader){
            this.createHeader();
        }
        //const errors = strings.error
        //const netMsg = strings.net

        return this.service.request(params).then((response) => {

            //let error  = response.error
            let data   = response.data.data
            if (isLogin){
                data   = response.data
            }
            let status = response.status

            if (status !== 200){
                return
            }

            if (params.method === 'PUT' || params.method === 'POST'){
                  if (!isLogin) {
                    const msg = "Guardado correctamente"
                    toast.notify(msg, {position:'top', duration: 5000})
                  }
            } else if (params.method === 'DELETE'){
                const msg = "Borrado correctamente"
                toast.notify(msg, {position:'top', duration: 5000})
            }

            callback(data, null)

        }).catch(err =>{
            console.log(err.response?.status, err)
            if(err.response !== undefined && err.response.data !== undefined){
              let bodyError = err.response.data;
              if (bodyError && bodyError.message){
                toast.notify(bodyError.message, {position:'top', duration: 10000})
              }else if (params.method === 'PUT' || params.method === 'POST'){
                    if (!isLogin){
                        const msg = "Error al guardar"
                        toast.notify(msg, {position:'top', duration: 10000})
                    }
              } else if (params.method === 'DELETE'){
                    if (!isLogin){
                        const msg = "Error al borrar"
                        toast.notify(msg, {position:'top', duration: 10000})
                    }
              }
            } else if (params.method === 'PUT' || params.method === 'POST'){
                  if (!isLogin){
                    const msg = "Error al guardar"
                    toast.notify(msg, {position:'top', duration: 10000})
                  }
            } else if (params.method === 'DELETE'){
                const msg = "Error al borrar"
                toast.notify(msg, {position:'top', duration: 10000})

            }
            callback(null, err)
        });
    }

    get(path, callback) {
        let params = {
            method: 'GET',
            url: this.HOST+path,
            responseType: 'json'
        }
        return this.doRequest(params, callback)
    }

    getExport(path, callback) {
        let params = {
            method: 'GET',
            url: this.HOST2+path,
            responseType: 'json'
        }
        return this.doRequest(params, callback)
    }

    patch(path, payload, callback) {
        let params = {
            method: 'PATCH',
            url: this.HOST+path,
            responseType: 'json',
            data: payload
        }
        return this.doRequest(params, callback)
    }

    post(path, payload, callback, isLogin=false) {
        let params = {
            method: 'POST',
            url: this.HOST+path,
            responseType: 'json',
            data: payload
        }
        return this.doRequest(params, callback, isLogin)
    }

    postMultipart(url, file, callback, isLogin=false){

        let formData = new FormData();
        formData.append('file', file);

        let params = {
            method: 'POST',
            url: this.HOST+url,
            data: formData,
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        return this.doRequest(params, callback, isLogin)
    }

    postMultipartImport(url, file, callback, isLogin=false){

        let formData = new FormData();
        formData.append('file', file);

        let params = {
            method: 'POST',
            url: this.HOST2+url,
            data: formData,
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        return this.doRequest(params, callback, isLogin)
    }

    delete(path, callback) {
        let params = {
            method: 'DELETE',
            url: this.HOST+path,
            responseType: 'json'
        }
        return this.doRequest(params, callback)
        //return this.service.delete(path).then((response) => callback(response.status, response.data));
    }

    put(path, payload, callback) {


        let params = {
            method: 'PUT',
            url: this.HOST+path,
            responseType: 'json',
            data: payload
        }
        return this.doRequest(params, callback, false)

    }
}
export default new BaseService();
